import { ErrorCodes } from './enums/error-codes.enum';

export class RawErrorItem {
  errorCode: ErrorCodes;
  message: string;
  memberName: string;
  details: string = '';

  constructor(data: {
    errorCode: ErrorCodes;
    message: string;
    memberName: string;
  }) {
    this.errorCode = data.errorCode;
    this.message = data.message;
    this.memberName = data.memberName;
  }
}

export class RawHttpErrorResponse {
  errors: RawErrorItem[] = [];
  isException: boolean;
  exceptionTag: string | null = null;

  get status(): number {
    return this.localStatus;
  }
  get rawData(): any {
    return this.localRawData;
  }
  get url(): string {
    return this.localUrl;
  }

  private localRawData: any;
  private localStatus: number;
  private localUrl: string;

  constructor(rawData: any) {
    this.localRawData = rawData;
    this.localStatus = (rawData && rawData.status) || null;
    this.localUrl = (rawData && rawData.url) || null;
    this.isException = !!rawData.exceptionTag;
    this.exceptionTag = rawData.exceptionTag ?? null;
  }

  addError(data: {
    errorCode: ErrorCodes;
    message: string;
    memberName: string;
  }): RawErrorItem {
    const rawError = new RawErrorItem(data);
    this.errors.push(rawError);

    return rawError;
  }
}
